export {
  isExternalLink,
  isInternalLink,
  isSpecialLink,
} from '@packages/shared-ui';

import { isExternalLink } from '@packages/shared-ui';
import { getBaseUrlByEnv } from '@/constants/baseUrls';

const currentTabHrefPrefixes = [
  'https://careers.sunrun.com/us/en',
  'https://www.sunrun.com',
  getBaseUrlByEnv(),
];

/**
 * @deprecated The method should not be used for new components.
 * use isInternalLink instead.
 */
export const openLinkCurrentTab = (link: string | undefined) => {
  return !isExternalLink(link, {
    internalHrefPrefixes: currentTabHrefPrefixes,
  });
};

export function removeLeadingSlash(str: string) {
  return str.replace(/^\//, '');
}

const BLOB_BLURB_LENGTH_CHARS = 100;

export function getBlogBlurb(text: string) {
  return `${text.slice(0, BLOB_BLURB_LENGTH_CHARS)}...`;
}

const templateReplaceRegex = new RegExp(/\{\{.*?\}\}/g, 'g');
export const replaceTemplate = (str: string, value: string) => {
  return str.replace(templateReplaceRegex, value);
};

export const stringHasTemplate = (str: string) =>
  str.match(templateReplaceRegex) !== null;
